import React, {useMemo} from "react";

import {useHome} from "../HomeContext";

import Gallery from "../../Gallery";


const HomePhotos = () => {
    const {photos, deletePhoto, movePhoto, appendPhoto} = useHome();

    const galleryPhotos = useMemo(
        () => photos.map(p => ({id: p.id, src: p.imgSquare, alt: p.title})),
        [photos]
    );

    return <Gallery photos={galleryPhotos}
                    onCreatePhoto={appendPhoto}
                    onPositionChange={movePhoto}
                    onDeletePhoto={deletePhoto}/>
}

export default HomePhotos;